import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import './CallFooter.scss';

import PlayArrow from '@material-ui/icons/PlayArrow';
import Pause from '@material-ui/icons/Pause';
import Room from '@material-ui/icons/Room';

import { getEmotionColor } from '../../helpers/emotion_helpers';

class CallFooter extends Component {
  static propTypes = {
    call: PropTypes.object.isRequired,
    highlightedEmotion: PropTypes.string,
    highlightedParticipant: PropTypes.object,
    highlightedVariable: PropTypes.string,
    updateTime: PropTypes.func.isRequired,
    setTime: PropTypes.func.isRequired,
    setTimeRatio: PropTypes.func.isRequired,
    startTime: PropTypes.func.isRequired,
    stopTime: PropTypes.func.isRequired,
    audioTime: PropTypes.number.isRequired,
    audioPaused: PropTypes.bool.isRequired,
    setAudioRef: PropTypes.func.isRequired,
    audio: PropTypes.object,
    canLoadAudioAndVideo: PropTypes.bool,
  };

  state = {
    audioEl: null,
  };

  componentDidMount() {
    // start audio listener to update location.
    setInterval(() => {
      !this.props.audioPaused && this.props.updateTime(this.props.audio.currentTime);
    }, 334); // To ensure animatinos that use seconds update smoothly
  }

  getTranslateX = () => {
    if (!this.state.audioEl) return 0;
    const { width } = this.state.audioEl.getBoundingClientRect();
    const ratio = this.props.audioTime / this.props.call?.duration_seconds;
    const translateX = _.max([_.min([width, ratio * width]), 0]);
    return translateX;
  };

  getMessageWidth = (msg) => {
    if (!this.state.audioEl) return 0;
    const performanceCacheKey = `msg-width-${msg.start_time_seconds}`; // Use local storage for performance
    if (this[performanceCacheKey]) return this[performanceCacheKey];
    const { width } = this.state.audioEl.getBoundingClientRect();
    const ratio = (msg.end_time_seconds - msg.start_time_seconds) / this.props.call?.duration_seconds;
    const elWidth = ratio * width;
    this[performanceCacheKey] = elWidth;
    return elWidth;
  };

  getMessageTranslateX = (msg) => {
    if (!this.state.audioEl) return 0;
    const performanceCacheKey = `msg-translate-${msg.start_time_seconds}`; // Use local storage for performance
    if (this[performanceCacheKey]) return this[performanceCacheKey];
    const { width } = this.state.audioEl.getBoundingClientRect();
    const translateX = (width * msg.start_time_seconds) / this.props.call?.duration_seconds;
    this[performanceCacheKey] = translateX;
    return translateX;
  };

  isMsgHighlighted = (msg) => {
    const { highlightedEmotion, highlightedParticipant } = this.props;
    if (highlightedEmotion && highlightedEmotion !== msg.emotion) return false;
    if (highlightedParticipant && highlightedParticipant?.id !== msg.speaker?.id) return false;
    return true;
  };

  getMomentWidth = (moment) => {
    if (!this.state.audioEl) return 0;
    const { width } = this.state.audioEl.getBoundingClientRect();
    const ratio = (moment.end_time - moment.start_time) / this.props.call?.duration_seconds;
    const elWidth = ratio * width;
    return elWidth;
  };

  getMomentTranslateX = (moment) => {
    if (!this.state.audioEl) return 0;
    const { width } = this.state.audioEl.getBoundingClientRect();
    const translateX = (width * moment.start_time) / this.props.call?.duration_seconds;
    return translateX;
  };

  isMomentHighlighted = (moment) => {
    // const { highlightedEmotion, highlightedParticipant } = this.props;
    // if (highlightedEmotion && highlightedEmotion !== msg.emotion) return false;
    // if (highlightedParticipant && highlightedParticipant?.id !== msg.speaker?.id) return false;
    return true;
  };

  clickAudioEl = (e) => {
    const { x, width } = this.state.audioEl.getBoundingClientRect();
    const audioLeft = x;
    const clickX = e.clientX;
    const realRatio = (clickX - audioLeft) / width;
    const validRatio = _.max([_.min([1, realRatio]), 0]);
    this.props.setTimeRatio(validRatio);
    window.__ADD_EVENT__('Call - Click Audio Bar', { call: this.props.call });
  };

  render() {
    const { call, audio, audioPaused } = this.props;
    const { moments } = call;
    const audio_only_s3_url = call?.recording?.audio_only_s3_url;
    // const video_url = audio_only_s3_url?.replace('audio_only', 'active_speaker').split('?')[0];
    // console.log({ video_url, audio_only_s3_url });
    return (
      <div className='call-footer-outer-container'>
        <div className='call-footer-inner-container'>
          <div className='controls'>
            {!!this.props.audio && audioPaused ? (
              <div onClick={this.props.startTime} className='play'>
                <PlayArrow />
              </div>
            ) : (
              <div onClick={this.props.stopTime} className='pause'>
                <Pause />
              </div>
            )}
          </div>
          <div ref={(ref) => !this.state.audioEl && this.setState({ audioEl: ref })} onClick={this.clickAudioEl} className='audio'>
            <div style={{ transform: `translateX(${this.getTranslateX().toFixed(1)}px)` }} className='audio-tracker' />
            {call.messages?.map((msg) => (
              <div
                key={msg.start_time_seconds}
                style={{
                  width: `${this.getMessageWidth(msg)}px`,
                  // height: `${80 * msg?.summary?.prob_sentiment_positive_smoothed}px`,
                  transform: `translateX(${this.getMessageTranslateX(msg)}px)`,
                  background: getEmotionColor(msg.emotion),
                }}
                className={cn('message', { highlighted: this.isMsgHighlighted(msg) })}
              />
            ))}
            {moments?.map((moment) => (
              <div
                key={moment.start_time}
                style={{
                  transform: `translateX(${this.getMomentTranslateX(moment)}px)`,
                  background: getEmotionColor(moment.emotion),
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.setTime(moment.start_time);
                }}
                className={cn('moment', { highlighted: this.isMomentHighlighted(moment) })}
              >
                <Room
                  style={{
                    color: getEmotionColor(moment.emotion),
                  }}
                />
                <div className={cn('explainer', { 'has-summary': !!moment.summary })}>
                  <div className='name'>{moment.name}</div>
                  <div className='summary'>{moment.summary}</div>
                </div>
                <div
                  style={{
                    width: `${this.getMomentWidth(moment)}px`,
                  }}
                  className='highlighted-section'
                ></div>
              </div>
            ))}
          </div>
        </div>
        {this.props.canLoadAudioAndVideo && (
          <audio ref={(ref) => this.props.setAudioRef(ref)}>
            <source src={audio_only_s3_url} type='audio/mpeg' />
          </audio>
        )}
      </div>
    );
  }
}

export default CallFooter;
